import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  static values = { hidden: { type: Boolean, default: true } }

  connect() {
    this.boundHandleTurboStream = this.handleTurboStream.bind(this)
    document.addEventListener('turbo:before-stream-render', this.boundHandleTurboStream)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.boundHandleTurboStream)
  }

  toggle() {
    this.hiddenValue = !this.hiddenValue
    this.updateVisibility()
    this.updateButtonText()
  }

  updateVisibility() {
    const statuses = ['completed', 'no_show', 'cancelled']
    const rows = statuses.flatMap(status =>
      [...document.querySelectorAll(`tr[data-reservation-status="${status}"]`)]
    )

    if (this.hiddenValue) {
      rows.forEach(row => {
        row.style.transition = 'opacity 0.3s ease'
        row.style.opacity = '0'
      })
      setTimeout(() => {
        rows.forEach(row => row.classList.add('d-none'))
      }, 300)
    } else {
      rows.forEach(row => {
        row.classList.remove('d-none')
        row.style.opacity = '0'
      })
      requestAnimationFrame(() => {
        rows.forEach(row => {
          row.style.transition = 'opacity 0.3s ease'
          row.style.opacity = '1'
        })
      })
    }
  }

  updateButtonText() {
    this.buttonTarget.textContent = this.hiddenValue ? 'Show All' : 'Hide Completed'
  }

  handleTurboStream(event) {
    if (!this.hiddenValue) return

    const statuses = ['completed', 'no_show', 'cancelled']
    const fragment = event.detail.newStream.querySelector('template')?.content
    if (!fragment) return

    const row = fragment.querySelector('tr[data-reservation-status]')
    if (row && statuses.includes(row.dataset.reservationStatus)) {
      row.classList.add('d-none')
    }
  }
}
